const Integrations = {
  amplitude: {
    appName: 'Amplitude',
    logo: 'https://20277870.fs1.hubspotusercontent-na1.net/hubfs/20277870/__hs-marketplace__/AMPLITUDE_%5BMARK-CIRCLE%5D_BLUE-1.png'
  },
  jira: {
    appName: 'Jira',
    logo: 'https://cdn2.hubspot.net/hubfs/521324/New%20Jira%20Logo-1.png'
  },
  adobeExpress: {
    appName: 'Adobe Express',
    logo: 'https://521324.fs1.hubspotusercontent-na1.net/hubfs/521324/__hs-marketplace__/Adobe_Express_logo_RGB_1024px-1.png'
  },
  aircall: {
    appName: 'Aircall',
    logo: 'https://cdn2.hubspot.net/hubfs/875767/Aircall_Logo_Icon-1.png'
  },
  linkedIn: {
    appName: 'LinkedIn',
    logo: 'https://cdn2.hubspot.net/hubfs/521324/App-Icon-1200x1200-linkedin-2.png'
  },
  microsoftTeams: {
    appName: 'Microsoft Teams',
    logo: 'https://f.hubspotusercontent20.net/hubfs/521324/__hs-marketplace__/Logo%20%7C%20Microsoft%20Teams-1.png'
  },
  salesforce: {
    appName: 'Salesforce',
    logo: 'https://cdn2.hubspot.net/hubfs/521324/App-Icon-1200x1200-salesforce.png'
  },
  zohoCRM: {
    appName: 'Zoho CRM',
    logo: 'https://521324.fs1.hubspotusercontent-na1.net/hubfs/521324/__hs-marketplace__/crm-512%20(1)-1.png'
  },
  pipedrive: {
    appName: 'Pipedrive',
    logo: 'https://f.hubspotusercontent20.net/hubfs/521324/__hs-marketplace__/Pipedrive_letter_logo_light-1.png'
  },
  microsoftDynamics365: {
    appName: 'Microsoft Dynamics 365',
    logo: 'https://f.hubspotusercontent20.net/hubfs/521324/__hs-marketplace__/dynamics-home-logo-2-1.png'
  },
  clioManage: {
    appName: 'Clio Manage',
    logo: 'https://hubspot-integrators-prod.s3.amazonaws.com/listing/283636.png'
  },
  copper: {
    appName: 'Copper',
    logo: 'https://hubspot-integrators-prod.s3.amazonaws.com/listing/236648.png'
  },
  zoom: {
    appName: 'Zoom',
    logo: 'https://f.hubspotusercontent20.net/hubfs/521324/__hs-marketplace__/Zoom%20-%20Camera-1.png'
  },
  zapier: {
    appName: 'Zapier',
    logo: 'https://521324.fs1.hubspotusercontent-na1.net/hubfs/521324/__hs-marketplace__/150px-1.png'
  },
  zendesk: {
    appName: 'Zendesk',
    logo: 'https://hubspot-integrators-prod.s3.amazonaws.com/listing/236010.jpg'
  },
  mailchimp: {
    appName: 'Mailchimp',
    logo: 'https://cdn2.hubspot.net/hubfs/521324/App-Icon-1200x1200-mailchimp.png'
  }
};
export const getIntegrations = nav => {
  switch (nav) {
    case 'smart-crm':
      {
        return [Integrations.microsoftTeams, Integrations.zoom, Integrations.zapier, Integrations.zendesk, Integrations.mailchimp];
      }
    default:
      {
        return [Integrations.amplitude, Integrations.jira, Integrations.adobeExpress, Integrations.aircall, Integrations.linkedIn, Integrations.microsoftTeams];
      }
  }
};